import { render, staticRenderFns } from "./UserImpersonate.vue?vue&type=template&id=07e54335"
import script from "./UserImpersonate.vue?vue&type=script&lang=js"
export * from "./UserImpersonate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07e54335')) {
      api.createRecord('07e54335', component.options)
    } else {
      api.reload('07e54335', component.options)
    }
    module.hot.accept("./UserImpersonate.vue?vue&type=template&id=07e54335", function () {
      api.rerender('07e54335', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/UserImpersonate.vue"
export default component.exports